import { gql } from "@apollo/client"

export const GET_STATION_CONFIGS = gql`
  query StationConfigs($domain: String!, $ids: [Int!]!, $valueType: Int) {
    station {
      configs(domain: $domain, stationIds: $ids, valueType: $valueType) {
        station_config_id
        station_id
        value_type
        value
        value_min
        value_max
      }
    }
  }
`

export interface StationConfig {
  station_config_id: number
  station_id: number
  value_type: number
  value: number
  value_min: number
  value_max: number
} 

export interface StationConfigResponse {
  station: {
    configs: StationConfig[]
  }
}

export const MUTATE_STATION_CONFIG = gql`
  mutation UpsertStationConfigs($domain: String!, $configs: [MutateStationConfig!]!) {
    station {
      upsertStationConfigs(domain: $domain, configs: $configs) {
        code
        success
        message
        updatedValues {
          station_config_id
          station_id
          value_type
          value
          value_min
          value_max
        }
      }
    }
  }
`

export interface UpsertStationConfigsRepsonse {
  station: {
    upsertStationConfigs: {
      code: string,
      success: boolean,
      message: string,
      updatedValues?: StationConfig[]
    }
  }
}